import styled from "styled-components";
import { tablet } from "styles/breakpoints";

export const CardContainer = styled.div`
  background-color: #ffffff;
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  width: 100%;
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  cursor: pointer;
  user-select: none;

  @media (min-width: ${tablet}px) {
    padding: 20px 24px;
  }
`;

export const HeaderLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1;
  min-width: 0;
`;

export const Title = styled.h3`
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  color: #4a4d5e;

  @media (min-width: ${tablet}px) {
    font-size: 20px;
    line-height: 28px;
  }
`;

export const ActionsRow = styled.div`
  display: flex;
  gap: 16px;

  @media (min-width: ${tablet}px) {
    gap: 24px;
  }
`;

export const ActionLink = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0;
  font-size: 14px;
  font-weight: 500;
  color: #798ecf;
  background: transparent;
  border: none;
  cursor: pointer;
  transition: color 0.2s;
  text-decoration: none;

  &:hover {
    color: #5a6fb0;
    text-decoration: underline;
  }

  &:focus {
    outline: none;
    text-decoration: underline;
  }

  svg {
    width: 18px;
    height: 18px;
    flex-shrink: 0;
  }
`;

export const ExpandChevron = styled.div<{ $isExpanded: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  color: #6b6b76;
  transition: transform 0.3s ease;
  transform: ${({ $isExpanded }) =>
    $isExpanded ? "rotate(180deg)" : "rotate(0)"};

  svg {
    width: 24px;
    height: 24px;
  }
`;

export const ExpandedBody = styled.div`
  padding: 0 20px 20px;
  border-top: 1px solid #eeeeee;

  @media (min-width: ${tablet}px) {
    padding: 0 24px 24px;
  }
`;

export const ReportContent = styled.div`
  padding-top: 16px;
  font-size: 14px;
  line-height: 1.6;
  color: #4a4d5e;

  @media (min-width: ${tablet}px) {
    font-size: 15px;
  }

  h1, h2, h3, h4, h5, h6 {
    color: #4a4d5e;
    margin-top: 16px;
    margin-bottom: 8px;
  }

  h1 { font-size: 22px; }
  h2 { font-size: 18px; }
  h3 { font-size: 16px; }

  p {
    margin: 0 0 12px;
  }

  ul, ol {
    margin: 0 0 12px;
    padding-left: 24px;
  }

  li {
    margin-bottom: 4px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    margin: 12px 0;
  }

  th, td {
    padding: 8px 12px;
    border: 1px solid #dedee3;
    text-align: left;
  }

  th {
    background-color: #f5f5f7;
    font-weight: 600;
  }

  a {
    color: #798ecf;
  }
`;
